import { FleetAreaCode, type FleetVehicleDetail } from '@gb-ticket/shared-types';

import { cn } from '@/lib/utils';
import {
  FLEET_FUEL_LABELS,
  formatFleetDueDate,
  isFleetDateOverdue,
} from '@/products/fleet/features/fleet-labels';
import { fleetAreaOn, useFleetAreas } from '@/products/fleet/features/use-fleet-areas';
import { fleetPanelClassName } from '@/products/fleet/features/fleet-panel';
import { FleetStatusBadge } from '@/products/fleet/features/fleet-status-badge';

export function FleetVehicleDetailStrip({ vehicle }: { vehicle: FleetVehicleDetail }) {
  const areas = useFleetAreas();
  const deadlinesOn = fleetAreaOn(areas.isError ? undefined : areas.data, FleetAreaCode.DEADLINES);
  return (
    <div
      className={cn(
        fleetPanelClassName,
        'flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6 sm:gap-y-2',
      )}
    >
      <p className="text-2xl font-semibold tracking-tight text-primary sm:text-3xl">
        {vehicle.licensePlate}
      </p>
      <FleetStatusBadge status={vehicle.operationalStatus} />
      <p className="text-sm text-muted-foreground sm:text-base">
        <span className="text-foreground">
          {vehicle.make} {vehicle.model}
        </span>
        <span aria-hidden="true"> · </span>
        <span>{FLEET_FUEL_LABELS[vehicle.fuelType]}</span>
      </p>
      {vehicle.holderName ? (
        <p className="text-sm text-muted-foreground">
          Fahrer: <span className="text-foreground">{vehicle.holderName}</span>
        </p>
      ) : null}
      {vehicle.currentKm != null ? (
        <p className="text-sm text-muted-foreground">
          Kilometer:{' '}
          <span className="text-foreground">{vehicle.currentKm.toLocaleString('de-DE')} km</span>
        </p>
      ) : null}
      {deadlinesOn ? (
        <p className="text-sm text-muted-foreground">
          Nächste HU:{' '}
          <span
            className={
              vehicle.hu.missingRegistration
                ? 'font-medium text-amber-800 dark:text-amber-300'
                : isFleetDateOverdue(vehicle.hu.dueOn)
                  ? 'font-medium text-destructive'
                  : 'text-foreground'
            }
          >
            {vehicle.hu.missingRegistration
              ? 'Erstzulassung fehlt'
              : vehicle.hu.dueOn
                ? formatFleetDueDate(vehicle.hu.dueOn)
                : '—'}
          </span>
        </p>
      ) : null}
    </div>
  );
}
